import { render } from "./ContactRequestSentView.vue?vue&type=template&id=49b9e1f3"
import script from "./ContactRequestSentView.vue?vue&type=script&lang=js"
export * from "./ContactRequestSentView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__